// Copyright © Aptos
// SPDX-License-Identifier: Apache-2.0

export const DEFAULT_FRONTEND_URL = 'https://aptosconnect.app';
